var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLigue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.538,
    height: 11.538,
    viewBox: "0 0 11.538 11.538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.361,1.731A.363.363,0,0,1,0,1.37V.361A.363.363,0,0,1,.361,0,.363.363,0,0,1,.721.361V1.37A.363.363,0,0,1,.361,1.731Z",
    transform: "translate(5.481 7.572)",
    fill: "#3b3939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.529,2.163H0V1.322A1.321,1.321,0,0,1,1.322,0H4.207A1.321,1.321,0,0,1,5.529,1.322ZM.721,1.442H4.808v-.12a.6.6,0,0,0-.6-.6H1.322a.6.6,0,0,0-.6.6v.12Z",
    transform: "translate(3.077 8.774)",
    fill: "#3b3939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13.721H.361A.363.363,0,0,1,0,.361.363.363,0,0,1,.361,0H6.13A.363.363,0,0,1,6.49.361.363.363,0,0,1,6.13.721Z",
    transform: "translate(2.596 10.216)",
    fill: "#3b3939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.363,4.269a.366.366,0,0,1-.274-.125.356.356,0,0,1-.058-.38A2.957,2.957,0,0,0,.276,2.572V1.13A1.57,1.57,0,0,0,.19.625C.185.611.18.591.175.572A1.082,1.082,0,0,1,.156.361.363.363,0,0,1,.517,0H.805A1.589,1.589,0,0,1,2.368,1.611,2.835,2.835,0,0,1,1.541,3.6c-.01.01-.038.034-.043.038a2.807,2.807,0,0,1-1.038.62A.333.333,0,0,1,.363,4.269ZM.964.736A2.183,2.183,0,0,1,1,1.13V2.572a3.836,3.836,0,0,1-.043.577l.082-.067a2.1,2.1,0,0,0,.611-1.471A.879.879,0,0,0,.964.736Z",
    transform: "translate(8.497 1.711)",
    fill: "#3b3939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.01,4.231A.3.3,0,0,1,1.9,4.211,2.675,2.675,0,0,1,.827,3.548,2.915,2.915,0,0,1,0,1.562,1.547,1.547,0,0,1,1.562,0h.312a.368.368,0,0,1,.3.163A.36.36,0,0,1,2.207.5a1.421,1.421,0,0,0-.115.577V2.524a2.976,2.976,0,0,0,.25,1.2.364.364,0,0,1-.062.385A.369.369,0,0,1,2.01,4.231ZM1.394.736a.833.833,0,0,0-.673.827,2.2,2.2,0,0,0,.63,1.49.415.415,0,0,0,.067.062,3.5,3.5,0,0,1-.048-.591V1.082A2.792,2.792,0,0,1,1.394.736Z",
    transform: "translate(0.673 1.731)",
    fill: "#3b3939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.726,7.452A3.732,3.732,0,0,1,0,3.726V2.284A2.286,2.286,0,0,1,2.284,0H5.168A2.286,2.286,0,0,1,7.452,2.284V3.726A3.732,3.732,0,0,1,3.726,7.452ZM2.284.721A1.565,1.565,0,0,0,.721,2.284V3.726a3,3,0,0,0,6.009,0V2.284A1.565,1.565,0,0,0,5.168.721Z",
    transform: "translate(2.043 0.601)",
    fill: "#3b3939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H11.538V11.538H0Z",
    fill: "none",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLigue);
export default __webpack_public_path__ + "static/media/ligue.d532c441c184e4d6898aa2cb3c6e1995.svg";
export { ForwardRef as ReactComponent };